import React, { useCallback, useContext, useState } from 'react';
import { Col, notification, Popconfirm, Row } from 'antd';

import { useTranslation } from 'react-i18next';
import { startShift } from '../../../services/pos/pos';

import POSButton from '../POSButton';
import POSContext from '../POSContext';

const Startup = () => {
  const { setShift } = useContext(POSContext);
  const [disabled, setDisabled] = useState(false);
  const { t } = useTranslation();

  const handleStartShift = useCallback(() => {
    setDisabled(true);
    startShift()
      .then((shift) => {
        setShift(shift);
        setDisabled(false);
      })
      .catch((err) => {
        console.error(err);
        notification.error({
          message: err.message,
        });
        setDisabled(false);
      });
  }, [setShift]);

  return (
    <>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40 }}>
        <Col xs={{ span: 24 }} lg={{ span: 4, offset: 10 }}>
          <Popconfirm
            title={t('entity.pos.openShift.openShiftConfirmation')}
            onConfirm={handleStartShift}
            onCancel={() => null}
            disabled={disabled}
            okText={t('entity.pos.actions.yes')}
            cancelText={t('entity.pos.actions.no')}
          >
            <div>
              <POSButton
                title={t('entity.pos.openShift.openShift')}
                onClick={() => null}
                disabled={disabled}
                color="green"
              />
            </div>
          </Popconfirm>
        </Col>
      </Row>
    </>
  );
};

export default Startup;
